// https://vuex.vuejs.org/en/getters.html

export default {
  getContract : state => {
    console.log('getting contract')
    return state.contract
  },
  userDetails: state => {
    return state.user;
  },
  CRMTypes: state => {
  
    var list = state.user.organisation.crm_list
    var array = []

    for (var a = 0; a<list.length; a++) {
      var item = state.types.filter(item => item.reference == list[a])
      
      let dict = {}
      dict.description = item[0].description
      dict.headers = item[0].headers
      dict.category = item[0]
      
      let rows = state.objects.filter(item => item.category.reference == list[a])

      let details = [];
      // details need to be on the upper level to make the search functionallity work properly
      for (var b = 0; b < rows.length; b++) {
        // bringing details to the upper level
        details.push(rows[b].details);
        // add reference to upper level
        rows[b].details.reference = rows[b].reference;
      }
      dict.items = details;
      array.push(dict);
    }
    return array;
  },
  ManagedTypes: state => {
    var list = state.user.organisation.managed_list
    var array = []

    for (var a = 0; a<list.length; a++) {
      var item = state.types.filter(item => item.reference == list[a])
      
      let dict = {}
      dict.description = item[0].description
      dict.headers = item[0].headers
      dict.category = item[0]
      
      let rows = state.objects.filter(item => item.category.reference == list[a])

      let details = [];
      // details need to be on the upper level to make the search functionallity work properly
      for (var b = 0; b < rows.length; b++) {
        // bringing details to the upper level
        details.push(rows[b].details);
        // add reference to upper level
        rows[b].details.reference = rows[b].reference;
      }
      dict.items = details;
      array.push(dict);
    }
    return array;
  },

  objectDetails: state => {
    return state.object.details;
  },

  checkExistObject: state => (input, type, ref) => {
    console.log('calling checkExistObject', input, type, ref)
    if (input !== undefined) {
      if (
        state.objects.find(
          item =>
            item.details[type].toLowerCase() == input.toLowerCase() &&
            item.category.reference == ref
        ) !== undefined
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  },
  tempAddressName: state => {
    if (state.temp_address.id !== undefined) {
      var address =
        state.temp_address.straatnaam + " " + state.temp_address.huisnummer;

      if (state.temp_address.huisletter !== undefined) {
        address = address + "" + state.temp_address.huisletter;
      }
      if (state.temp_address.huisnummertoevoeging !== undefined) {
        address = address + "" + state.temp_address.huisnummertoevoeging;
      }
      return address;
    } else {
      return "";
    }
  },
  addressDescription: state => (new_state, object, temp_address) => {
    var output = "";
    if (!new_state) {
      if (object !== undefined) {
        if (
          object.details.address !== undefined &&
          object.details.address != ""
        ) {
          output += object.details.address + ", ";
        }
        if (
          object.details.postal_code !== undefined &&
          object.details.postal_code != ""
        ) {
          output += object.details.postal_code + " ";
        }
        if (object.details.city !== undefined && object.details.city != "") {
          output += object.details.city;
        }
        return output;
      }
    } else if (new_state) {
      if (temp_address !== undefined) {
        if (temp_address === undefined || temp_address == {}) {
          return "";
        } else {
          return temp_address.weergavenaam;
        }
      }
    } else if (new_state == null) {
      if (object !== undefined) {
        if (
          object.details.address !== undefined &&
          object.details.address != ""
        ) {
          output += object.details.address + ", ";
        }
        if (
          object.details.postal_code !== undefined &&
          object.details.postal_code != ""
        ) {
          output += object.details.postal_code + " ";
        }
        if (object.details.city !== undefined && object.details.city != "") {
          output += object.details.city;
        }
        return output;
      } else if (temp_address !== undefined) {
        if (temp_address === undefined || temp_address == {}) {
          return "";
        } else {
          return temp_address.weergavenaam;
        }
      }
    }
  },

  addressObjectDescription: state => (new_state, user, temp_address) => {
    var output = "";
    if (!new_state) {
      if (user !== undefined) {
        if (
          user.organisation.details.address !== undefined &&
          user.organisation.details.address != ""
        ) {
          output += user.organisation.details.address + ", ";
        }
        if (
          user.organisation.details.postal_code !== undefined &&
          user.organisation.details.postal_code != ""
        ) {
          output += user.organisation.details.postal_code + " ";
        }
        if (user.organisation.details.city !== undefined && user.organisation.details.city != "") {
          output += user.organisation.details.city;
        }
        return output;
      }
    } else if (new_state) {
      if (temp_address !== undefined) {
        if (temp_address === undefined || temp_address == {}) {
          return "";
        } else {
          return temp_address.weergavenaam;
        }
      }
    } else if (new_state == null) {
      if (object !== undefined) {
        if (
          user.organisation.details.address !== undefined &&
          user.organisation.details.address != ""
        ) {
          output += user.organisation.details.address + ", ";
        }
        if (
          user.organisation.details.postal_code !== undefined &&
          user.organisation.details.postal_code != ""
        ) {
          output += user.organisation.details.postal_code + " ";
        }
        if (user.organisation.details.city !== undefined && user.organisation.details.city != "") {
          output += user.organisation.details.city;
        }
        return output;
      } else if (temp_address !== undefined) {
        if (temp_address === undefined || temp_address == {}) {
          return "";
        } else {
          return temp_address.weergavenaam;
        }
      }
    }
  },  
  headerHeight: state => vuetify => {
    if (vuetify.breakpoint.xs) {
      return "175px";
    } else {
      return "275px";
    }
  }, 
  showCreatedObject : state => {
    console.log('showCreateObject', state.createObject.show)
    return state.createObject.show
  }
};
